import { IconDotsVertical } from "@tabler/icons-react";
import ClientUtils from "../../utils/ClientUtils";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppMenuIcon = (props: Props) => {
  const { className, ...rest } = props;

  return (
    <IconDotsVertical
      {...rest}
      className={ClientUtils.twClassNames("", props.className)}
    />
  );
};
export default withIconSize(AppMenuIcon);
